declare var require: any;
import './store-carousel-grid.template.html';
import { store_carousel_grid_controller } from './store-carousel-grid.controller'

export var store_carousel_grid_component = {
    template: require('./store-carousel-grid.template.html'),
    controller: store_carousel_grid_controller,
    bindings: {
        item: "="
    }
}


// WEBPACK FOOTER //
// ./src/components/store-carousel-grid/store-carousel-grid.ts